export default __webpack_public_path__ + "static/media/pinGray.9dcc6c2e.svg";